import { cn } from "../lib/cn";

import { CopyButton } from "./CopyButton";

export function truncateAddress(address: string, lead = 8, tail = 6): string {
  if (address.length <= lead + tail + 2) return address;
  return `${address.slice(0, lead + 2)}\u2026${address.slice(-tail)}`;
}

export interface AddressDisplayProps {
  address: string;
  leadChars?: number;
  tailChars?: number;
  copyable?: boolean;
  copied?: boolean;
  onCopy?: () => void;
  fontSize?: number;
  color?: string;
  className?: string;
}

export function AddressDisplay({
  address,
  leadChars = 8,
  tailChars = 6,
  copyable,
  copied,
  onCopy,
  fontSize = 12,
  color = "var(--color-text)",
  className,
}: AddressDisplayProps) {
  return (
    <span
      className={cn("inline-flex items-center gap-2.5 font-mono", className)}
      style={{ fontSize, color }}
    >
      {truncateAddress(address, leadChars, tailChars)}
      {copyable && onCopy && (
        <CopyButton
          copied={copied ?? false}
          onClick={onCopy}
          fontSize={fontSize - 3}
        />
      )}
    </span>
  );
}
